var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandPointer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7504 8.19L12.3804 8.32L16.5504 10.4C17.2504 10.63 17.7104 11.32 17.6504 12.06V12.19V12.32L16.7504 18.44C16.6904 18.87 16.5004 19.27 16.1504 19.55C15.8404 19.85 15.4304 20 15.0004 20H8.12035C7.63035 20 7.18035 19.82 6.85035 19.47L0.860352 13.5L1.76035 12.5C2.00035 12.25 2.38035 12.11 2.74035 12.13H3.03035L7.00035 13V2.5C7.00035 1.96957 7.21107 1.46086 7.58614 1.08579C7.96121 0.710714 8.46992 0.5 9.00035 0.5C9.53078 0.5 10.0395 0.710714 10.4146 1.08579C10.7896 1.46086 11.0004 1.96957 11.0004 2.5V8.19H11.7504Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandPointer);
export default __webpack_public_path__ + "static/media/hand_pointer.aa405266959cb863080ea864e8b78243.svg";
export { ForwardRef as ReactComponent };